import React, { useMemo } from "react";
import { Avatar, Tooltip } from "antd";
import styled from "styled-components";

const ProviderRow = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
`;

const ProviderName = styled.span`
  font-size: 13px;
  color: #262626;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 140px;
`;

/**
 * Initials from a display name (e.g. "Mahlangu Logistics" → "ML").
 * @param {string|null|undefined} name
 * @returns {string}
 */
export function getProviderInitials(name) {
  if (!name || typeof name !== "string") return "?";
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return "?";
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase();
}

/**
 * @param {{ name?: string|null, size?: number, showName?: boolean }} props
 */
export default function ProviderAvatar({
  name = null,
  size = 28,
  showName = true,
}) {
  const displayName = name?.trim() || "Unassigned";
  const initials = useMemo(() => getProviderInitials(name), [name]);

  return (
    <Tooltip title={displayName}>
      <ProviderRow>
        <Avatar size={size} style={{ backgroundColor: name ? "#1890ff" : "#bfbfbf", flexShrink: 0 }}>
          {initials}
        </Avatar>
        {showName && <ProviderName>{displayName}</ProviderName>}
      </ProviderRow>
    </Tooltip>
  );
}
